import styled, { css } from 'styled-components'

import type { InteractiveTooltipProps } from '@components/ui/Tooltips'
import { InteractiveTooltip } from '@components/ui/Tooltips'

import { PAID_INSTALLMENT, PAID_YES } from '@constants'

export interface PaidStatusIndicatorProps extends Omit<InteractiveTooltipProps, 'children'> {
  className?: string
  value: InvoicePaidStatusValue
}

const StyledIndicatorSpan = styled('span').withConfig<{
  value: InvoicePaidStatusValue
}>({
  shouldForwardProp: (prop, defaultValidator) => {
    return !['value'].includes(prop) && defaultValidator(prop)
  },
})`
  display: inherit;
  width: 16px;
  height: 16px;
  background-color: ${({ theme, value }) =>
    value === PAID_YES ? theme.colors.success[150] : theme.colors.common.inactive};
  border-radius: 50%;
  margin: auto;

  ${({ theme, value }) =>
    value === PAID_INSTALLMENT &&
    css`
      position: relative;
      &:before {
        display: block;
        content: ' ';
        position: absolute;
        bottom: 0;
        height: 8px;
        width: 16px;
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
        background-color: ${theme.colors.success[150]};
      }
    `}
`

export function PaidStatusIndicator({ value, ...rest }: PaidStatusIndicatorProps) {
  return (
    <InteractiveTooltip {...rest}>
      <StyledIndicatorSpan value={value} />
    </InteractiveTooltip>
  )
}
